import platform from '@propertypal/shared/src/utils/platform';
import ProductsHeader from '@propertypal/web-ui/src/headers/products/ProductsHeader';
import EstateAgentsContent from '@propertypal/web-ui/src/products/EstateAgentsContent';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: `Estate Agents Products - ${platform.title}`,
  description:
    'View Our Range Of Agent And Developer Products And Solutions To Help Enhance Your Brand And Get Your Listings Seen By More People.',
  url: `/products/estate-agents`,
};

const EstateAgentsProducts = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ProductsHeader />
      <EstateAgentsContent />
      <ProductsContact reason="Estate Agent Products & Services" />
    </>
  );
};

export default EstateAgentsProducts;
